import { useSortable } from '@dnd-kit/sortable';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box } from '@mui/material';

export const DragHandle = ({ rowId }: { rowId: string }) => {
  const { attributes, listeners, setActivatorNodeRef } = useSortable({
    id: rowId,
  });

  return (
    <Box
      ref={setActivatorNodeRef} // ← ドラッグ起点をアイコンに限定
      {...listeners} // ← イベントもアイコンのみ
      {...attributes}
      sx={{
        cursor: 'grab',
        touchAction: 'none',
        display: 'flex',
        alignItems: 'center',
        color: (t) => t.palette.grey[500],
      }}
    >
      <DragIndicatorIcon fontSize="small" />
    </Box>
  );
};
